import { JSX, useEffect } from "react";

function Analytics(): JSX.Element {
	useEffect(() => {
		window.setTimeout(() => {
			const stat = document.createElement("script");
			stat.async = true;
			stat.src =
				"https://hm.baidu.com/hm.js?e303fa195567d2be50af56db1a114cb8";
			document.body.appendChild(stat);
		}, 1000);
	}, []);

	return <></>;
}

export default Analytics;
